import { mapMutations } from "vuex";

export const addPersonMixin = {
  data() {
    return {
      showPopup: false // Weather to show the popup or not
    };
  },
  methods: {
    ...mapMutations("addNew", {
      clear: "clear" // Empty the add new
    }),
    /**
     * Show the popup
     */
    showThePopup() {
      this.showPopup = true;
    },
    /**
     * Hide the popup
     */
    hideThePopup() {
      this.showPopup = false;
    }
  }
};
